import React, { ReactNode } from 'react';

import Typography from '../../library/typography/typography';
import {
  CheckCircleRegularIcon,
  StarRegularIcon,
  TagRegularIcon,
  TrophyRegularIcon
} from '../../shared/icons/icons';
import SearchButton from '../search-button/search-button';

import { RIDE_HEIGHT_TYPES } from '../../shared/constants/fitment';
import { SEARCH_TYPES } from '../../shared/constants/search-types';

import './fitment-search-type-cta.scss';

interface FitmentSearchTypeCtaProps {
  className?: string;
  href?: string;
  isSelected?: boolean;
  onClick?: (searchType: string) => void;
  rideHeightType?: string;
  searchType: string;
}

function FitmentSearchTypeCta(props: FitmentSearchTypeCtaProps) {
  const { onClick, rideHeightType, searchType, ...imageCtaProps } = props;

  const SEARCH_TYPE_TO_LABEL = {
    [SEARCH_TYPES.ACCESSORIES]: 'Accessories',
    [SEARCH_TYPES.BEST]: 'Best Seller',
    [SEARCH_TYPES.HIGHEST]: 'Highest Rated',
    [SEARCH_TYPES.INVENTORY_STATUS]: 'In Stock',
    [SEARCH_TYPES.STORE_IN_STOCK]: 'In Stock',
    [SEARCH_TYPES.OE]: 'Original Equipment',
    [SEARCH_TYPES.PACKAGE]: 'Tire & Wheel Package',
    [SEARCH_TYPES.PROMOTION]: 'On Promotion',
    [SEARCH_TYPES.TIRES]: 'Tires',
    [SEARCH_TYPES.WHEELS]: 'Wheels'
  };

  let display: ReactNode | null = null;

  if (searchType === SEARCH_TYPES.BEST) {
    display = (
      <span styleName="icon-container">
        <TrophyRegularIcon styleName="icon" />
      </span>
    );
  } else if (searchType === SEARCH_TYPES.HIGHEST) {
    display = (
      <span styleName="icon-container">
        <StarRegularIcon styleName="highest-rated-icon" />
      </span>
    );
  } else if (
    searchType === SEARCH_TYPES.INVENTORY_STATUS ||
    searchType === SEARCH_TYPES.STORE_IN_STOCK
  ) {
    display = (
      <span styleName="icon-container">
        <CheckCircleRegularIcon styleName="icon" />
      </span>
    );
  } else if (searchType === SEARCH_TYPES.OE) {
    display = (
      <div styleName="icon-container">
        <Typography styleName="oe-icon" variant="H6" weight="black">
          O.E.
        </Typography>
      </div>
    );
  } else if (searchType === SEARCH_TYPES.PACKAGE) {
    display = (
      <img
        alt={searchType}
        className="fitment-search-type-cta__cta-image"
        src="https://discounttire.scene7.com/is/image/discounttire/fitment-tire-and-wheel-packages-option?$FitmentCTA$"
        styleName="cta-image"
      />
    );
  } else if (searchType === SEARCH_TYPES.PROMOTION) {
    display = (
      <div styleName="icon-container">
        <TagRegularIcon styleName="icon" />
      </div>
    );
  } else if (searchType === SEARCH_TYPES.TIRES) {
    let imgSrc =
      'https://discounttire.scene7.com/is/image/discounttire/fitment-tires-option?$FitmentCTA$';

    if (rideHeightType === RIDE_HEIGHT_TYPES.LIFTED) {
      imgSrc =
        'https://discounttire.scene7.com/is/image/discounttire/fitment-tires-lifted-option?$FitmentCTA$';
    }
    display = (
      <img
        alt={searchType}
        className="fitment-search-type-cta__cta-image"
        src={imgSrc}
        styleName="cta-image"
      />
    );
  } else if (searchType === SEARCH_TYPES.WHEELS) {
    display = (
      <img
        alt={searchType}
        className="fitment-search-type-cta__cta-image"
        src="https://discounttire.scene7.com/is/image/discounttire/fitment-wheels-option?$FitmentCTA$"
        styleName="cta-image"
      />
    );
  } else if (searchType === SEARCH_TYPES.ACCESSORIES) {
    display = (
      <img
        alt={searchType}
        className="fitment-search-type-cta__cta-image"
        src="https://discounttire.scene7.com/is/image/discounttire/fitment-accesories-windshield-wiper-focus-option?$FitmentCTA$"
        styleName="cta-image"
      />
    );
  }

  return (
    <SearchButton
      className="fitment-search-type-cta"
      label={SEARCH_TYPE_TO_LABEL[searchType]}
      onClick={() => {
        onClick?.(searchType);
      }}
      {...imageCtaProps}
    >
      {display}
    </SearchButton>
  );
}

export default FitmentSearchTypeCta;
